import React from "react";
import PropTypes from "prop-types";
import { GlossaryButton } from "@learningblocks/storybook-components";
import { Notebook } from "@learningblocks/storybook-components";
import { DesignChapterContentBlock } from "./DesignChapterContentBlock";

export function DesignSectionContent(props) {
  const onSelectMenu = () => props.goToSection(props.nextMenuValue);
  return (
    <>
      <Notebook.IndexBlock className="book_index">
        <Notebook.Header className="book_index_header">
          <Notebook.DrawerIcon
            className="index-icon"
            collapsed={false}
            toggleCollapse={props.setNotebookVisible}
          />
          <Notebook.TitleBlock
            className="index-titleBlock"
            title={props.title}
            text={props.description}
            ariaLabel="Lab notebook secton heading."
          />
          <GlossaryButton className="index-glossaryIcon" />
        </Notebook.Header>
        <Notebook.DesignSectionMenu
          className="book_index_designChapter"
          onSelect={onSelectMenu}
          title={props.currentMenu.title}
          number={props.currentMenu.number}
          onClickInfo={props.onClickInfo}
        />
        <DesignChapterContentBlock />
      </Notebook.IndexBlock>
    </>
  );
}

DesignSectionContent.propTypes = {
  /**
   * Details of currently active menu in menu list
   */
  currentMenu: PropTypes.shape({
    /**
     * Index of menu
     */
    number: PropTypes.number,
    /**
     * Title of menu
     */
    title: PropTypes.string,
    /**
     * Value of menu
     */
    value: PropTypes.string,
  }),
  /**
   * Description to be displayed in Notebook Header
   */
  description: PropTypes.string,
  /**
   * Function to go to next section
   */
  goToSection: PropTypes.func,
  /**
   * Function to set new isNotebookVisible value
   */
  setNotebookVisible: PropTypes.func,
  /**
   * Title of the Content to display at header
   */
  title: PropTypes.string,
  /**
   * Value for next-in-line menu
   */
  nextMenuValue: PropTypes.oneOf([
    "CONTEXT",
    "TECHNIQUES",
    "DESIGN",
    "PROBLEM_SOLVING",
    "RESULTS",
    "REFLECTION",
    "TROUBLESHOOTING",
    "NONE",
  ]),
  /**
   * function to invoke on clicking info icon on Notebook section menu
   */
  onClickInfo: PropTypes.func,
};

DesignSectionContent.defaultProps = {};
